import React, {useEffect} from 'react';
import {useField} from 'formik';
import {useLocation} from 'react-router-dom';

import {useMediaQuery} from 'src/hooks/useMediaQuery';
import {parseQueryString} from 'shared/utils';
import {getScoresByTestType} from 'shared/portfolio/actions/test-scores';

import Act2025Form from './forms/act-2025-form';
import ActForm from './forms/act-form';
import ActPlanForm from './forms/act-plan-form';
import ApForm from './forms/ap-form';
import OtherForm from './forms/other-form';
import PreActForm from './forms/pre-act-form';
import PsatForm from './forms/psat-form';
import SatForm from './forms/sat-form';
import TestTypeSelector from './test-type-selector';

const TEST_TYPE_FORM_MAP = {
  actPlan: <ActPlanForm />,
  preAct: <PreActForm />,
  act: <ActForm />,
  act2025: <Act2025Form />,
  ap: <ApForm />,
  psat2015: <PsatForm />,
  psat: <PsatForm />,
  sat2016: <SatForm />,
  sat: <SatForm />,
  other: <OtherForm />,
};

const TestScoreInputs = () => {
  const mq = useMediaQuery();
  const [typeField, , typeHelpers] = useField('type');
  const [, , scoresHelpers] = useField('scores');
  const location = useLocation();
  const {tests} = parseQueryString(location.search.slice(1));

  useEffect(() => {
    const testsArray = tests?.split(',');

    if (location.pathname.includes('/test-score/new') && testsArray?.length === 1) {
      const testType = testsArray[0];

      typeHelpers.setValue(testType);
      scoresHelpers.setValue(getScoresByTestType(mq.MS_AND_DOWN)[testType]);
    }
  }, []);

  return (
    <>
      <legend className="shared-required-legend"></legend>
      {typeField.value ? TEST_TYPE_FORM_MAP[typeField.value] : <TestTypeSelector />}
    </>
  );
};

export default TestScoreInputs;
